import React from 'react';
import { motion } from 'framer-motion';
export function ProductContentsSection() {
  const contents = [{
    tomo: '01',
    title: 'El Escáner de Deudas',
    desc: 'Diagnóstico completo en BCRA y Veraz. Detectá deudas caducadas y armá tu plan inicial.'
  }, {
    tomo: '02',
    title: 'El Vacío Legal',
    desc: 'Cómo usar el Art. 26 para exigir la supresión de datos negativos paso a paso.'
  }, {
    tomo: '03',
    title: 'Blindaje vs. Cobranzas',
    desc: 'Frená el acoso y respondé amenazas con scripts exactos para cada situación.'
  }, {
    tomo: '04',
    title: 'Herramientas Legales',
    desc: 'Modelos listos para usar: cartas documento, notas de rectificación y formularios.'
  }, {
    tomo: '05',
    title: 'Presión Administrativa',
    desc: 'Qué hacer cuando no responden. Cómo armar el expediente y escalar con fuerza.'
  }, {
    tomo: '06',
    title: 'Recuperación Crediticia',
    desc: 'El sistema para volver a calificar y recuperar el acceso al crédito formal.'
  }];
  return <section className="w-full py-16 px-4 sm:px-6 lg:px-8 flex flex-col items-center" data-id="element-278">
      <div className="max-w-3xl mx-auto w-full" data-id="element-279">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-280">
          <div className="text-brand-gold text-[10px] font-bold tracking-[0.3em] uppercase mb-3" data-id="element-281">
            CONTENIDO PRINCIPAL
          </div>
          <h2 className="text-xl sm:text-2xl md:text-3xl font-extrabold text-white tracking-tight" data-id="element-282">
            Los <span className="text-brand-gold" data-id="element-283">6 Tomos</span> del MegaPack
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-284">
          {contents.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="flex flex-col gap-1.5 p-4 rounded-lg border border-brand-gold/15 hover:border-brand-gold/40 hover:shadow-[0_0_20px_rgba(201,168,76,0.06)] transition-all duration-300" style={{
          background: 'linear-gradient(135deg, #0d0b08 0%, #0a0a0a 100%)'
        }} data-id="element-285">
              <div className="flex items-center gap-3" data-id="element-286">
                <span className="inline-flex items-center justify-center w-7 h-7 rounded-md text-[10px] font-extrabold text-black shrink-0" style={{
              background: 'linear-gradient(135deg, #e8d48b 0%, #c9a84c 50%, #a8862a 100%)'
            }} data-id="element-287">
                  {item.tomo}
                </span>
                <h3 className="text-sm font-bold text-white leading-tight" data-id="element-288">
                  {item.title}
                </h3>
              </div>
              <p className="text-gray-500 text-xs leading-relaxed" data-id="element-289">
                {item.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}